import React from 'react';
import { useTranslation } from '../i18n/LanguageContext';

const LanguageSwitcher = ({ isScrolled }) => {
  const { language, switchLanguage } = useTranslation();

  return (
    <div className="flex items-center gap-2">
      <button
        onClick={() => switchLanguage('en')}
        className={`text-xs uppercase tracking-wider transition-colors ${
          language === 'en'
            ? isScrolled 
              ? 'font-medium text-brand-dark' 
              : 'font-medium text-white'
            : isScrolled
              ? 'font-normal text-brand-text-muted hover:text-brand-dark'
              : 'font-normal text-white/60 hover:text-white'
        }`}
      >
        EN
      </button>
      <span className={`text-xs ${
        isScrolled ? 'text-brand-text-muted' : 'text-white/60'
      }`}>
        |
      </span>
      <button
        onClick={() => switchLanguage('de')}
        className={`text-xs uppercase tracking-wider transition-colors ${
          language === 'de'
            ? isScrolled 
              ? 'font-medium text-brand-dark' 
              : 'font-medium text-white'
            : isScrolled
              ? 'font-normal text-brand-text-muted hover:text-brand-dark'
              : 'font-normal text-white/60 hover:text-white'
        }`}
      >
        DE
      </button>
    </div>
  );
};

export default LanguageSwitcher;
